import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from '../redux/hooks';
import { setSearchQuery } from '../redux/slices/searchSlice';

const SearchContainer = styled.div`
  width: 100%;
  height: 40px;
  align-items: center;
  grid-area: search;
  position: relative;
`;

const SearchInput = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding-right: 15px;
  padding-left: 40px;
  border: 0px;
  font-size: 14px;
  outline: none;
  background-color: #CBDED3;

  
  &:focus {
    background-color:rgb(178, 197, 186);
  }
`;

const SearchIcon = styled.div`
  width: 23px;
  height: 23px;
  background: url('/media/SearchIcon.png') no-repeat;
  background-size: 23px 23px;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

const ClearButton = styled.div`
  position: absolute;
  right: 15px;
  top: 9px;
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #3B6255;
  opacity: .5;
  font-weight: 900;
  color: #757575;
`;


const Search: React.FC = React.memo(() => {
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newQuery = e.target.value;
    setQuery(newQuery);
    dispatch(setSearchQuery(newQuery));
  }, [dispatch]);

  const handleKeyPress = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && query.trim()) {
      navigate(`/catalog?term=${encodeURIComponent(query.trim())}`);
    }
  }, [navigate, query]);

  const handleSubmit = useCallback(() => {
    if (query.trim()) {
      navigate(`/catalog?term=${encodeURIComponent(query.trim())}`);
    }
  }, [navigate, query]);
  
  return (
    <SearchContainer>
      <SearchInput 
        type="text" 
        placeholder="Пошук..." 
        value={query}
        onChange={handleSearch}
        onKeyDown={handleKeyPress}
      />
      <SearchIcon
        onClick={() => {
          if (query.trim()) handleSubmit();
        }}></SearchIcon>
      {query && (
        <ClearButton onClick={() => setQuery('')}>
          ✕
        </ClearButton>
      )}

    </SearchContainer>
  );
});

export default Search;